import type { ReactNode } from "react"

export function MdxProse({ children }: { children: ReactNode }) {
  return (
    <div className="prose max-w-none prose-neutral dark:prose-invert [&>*:first-child]:mt-0 [&>*:last-child]:mb-0">
      {children}
    </div>
  )
}
